
export const imgServerUrl = 'http://47.104.195.166/prod-api/';
export const uploadUrl = 'http://47.104.195.166/prod-api/';
export const baseServerUrl = 'http://47.104.195.166/prod-api/';
export const shareWebUrl = 'http://47.104.195.166/prod-api/';

// export const imgServerUrl = 'https://www.qdbxxh.com/prod-api/';
// export const uploadUrl = 'https://www.qdbxxh.com/prod-api/';
// export const baseServerUrl = 'https://www.qdbxxh.com/prod-api/';
// export const shareWebUrl = 'https://www.qdbxxh.com/prod-api/';



